export const isTrainerAssignmentActivityActive = (program, now = new Date()) => {
    const value = program?.endDate;
    if (!value || program.deletedAt) return false;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return false;
    const endDay = typeof value === "string" ? value.trim().slice(0, 10) : parsed.toISOString().slice(0, 10);
    const day = new Date(`${endDay}T00:00:00Z`);
    if (Number.isNaN(day.getTime()) || day.toISOString().slice(0, 10) !== endDay) return false;
    const today = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Africa/Addis_Ababa", year: "numeric", month: "2-digit", day: "2-digit",
    }).format(new Date(now));
    return endDay >= today;
};

export const canAssignTrainerActivity = (program, user, now) => {
    const isSystemAdmin = String(user?.data?.userRoles?.roleName || "").trim().toLowerCase() === "system admins";
    const providerId = Number(user?.data?.cpdProviderId);
    const activityProviderId = Number(program?.cpdProviderId ?? program?.cpdProvider?.id);
    const ownsActivity = Number.isSafeInteger(providerId) && providerId > 0 && providerId === activityProviderId;
    return (isSystemAdmin || ownsActivity) && isTrainerAssignmentActivityActive(program, now);
};
